import { useTheme } from '@emotion/react';
import React from 'react';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { Icon, Title, Text } from '@vmos2/design-system';

type Props = {
  hasSelectors: boolean,
  hasEnabledStores: boolean,
  channel: string,
};

export const Unavailable = ({ hasSelectors, channel, hasEnabledStores }: Props) => {
  const theme = useTheme();
  const { t } = useTranslation('landing');

  return (
    <NoSelectorWrapper hasSelectors={hasSelectors}>
      {!hasEnabledStores && !hasSelectors && (
        <Title level={1} margin="large" align="center">
          {t('ourStores')}
        </Title>
      )}
      <IconWrapper name="StoreSlash" fill={theme.color.lightGrey} size={80} />
      <Title level={2} margin="xsmall" align="center">
        {hasSelectors
          ? t('storeUnavailableTitleAppType', { appType: t(channel) })
          : t(hasEnabledStores ? 'storeClosedTitle' : 'storeUnavailableTitle')}
      </Title>
      <Text margin="large" align="center" color={theme.color.grey}>
        {t(hasSelectors ? 'storeUnavailableSubTitleAppType' : 'storeClosedSubtitle')}
      </Text>
    </NoSelectorWrapper>
  );
};

const IconWrapper = styled(Icon)`
  display: flex;
  margin: 0 auto 24px;
`;

const NoSelectorWrapper = styled('div')`
  @media (${({ theme }) => theme.breakpoint.tablet}) {
    top: ${({ hasSelectors }) => (hasSelectors ? '0' : '25%')};
    position: relative;
  }

  @media (${({ theme }) => theme.breakpoint.mobile}) {
    padding: 0 12px;
  }
`;
